import errorManager from '@/rollbar.js';

const openModal = () => {
  document.querySelector('#profile-therapies-modal').addEventListener('click', (e) => {
    eventBus.$emit('openProfileTherapiesModal');
  });
};
const init = () => {
  try {
    openModal();
  } catch (e) {
    errorManager(e);
  }
};

window.ProfileTherapiesModalActivation = {
  init: init,
};
